export enum AddressType {
  Billing = 'billing',
  Delivery = 'delivery',
}

export interface Address {
  id?: string
  name?: string
  address?: string
  city?: string
  state?: string
  zip?: string
  country?: string
  phone_number?: string
  default?: boolean
  street?: string
  place_id?: string
}

export type BillingAddress = Address
export type DeliveryAddress = Address
